/* assets/custom-upsell-carousel.js */

(function () {
  'use strict';

  class CustomUpsellCarousel {
    constructor(root) {
      this.root = root;
      this.forms = root.querySelectorAll('[data-custom-upsell-carousel-form]');
      this.defaultText = root.dataset.buttonText || 'До кошика';
      this.loadingText = root.dataset.loadingText || 'Додаємо...';
      this.successText = root.dataset.successText || 'Додано';
      this.errorText = root.dataset.errorText || 'Не вдалося додати';
      this.redirectToCart = root.dataset.redirectToCart === 'true';
      this.cartType = root.dataset.cartType || 'drawer';
      this.init();
    }

    init() {
      this.forms.forEach((form) => {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.addToCart(form);
        });
      });
    }

    async addToCart(form) {
      const button = form.querySelector('[data-custom-upsell-carousel-button]');
      const label = form.querySelector('[data-custom-upsell-carousel-label]');
      const errorBox = form.querySelector('[data-custom-upsell-carousel-error]');

      if (!button || button.disabled || button.dataset.busy === 'true') return;

      button.dataset.busy = 'true';
      this.hideError(errorBox);
      this.setButtonState(button, label, 'loading');

      const formData = new FormData(form);
      const sections = this.getSectionsToRender();

      if (sections.length) {
        formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });

        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || this.errorText);
        }

        this.updateCartUI(data);
        this.setButtonState(button, label, 'success');

        if (this.redirectToCart) {
          window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
          return;
        }

        this.openCart();

        window.setTimeout(() => {
          this.setButtonState(button, label, 'default');
          button.dataset.busy = 'false';
        }, 1600);
      } catch (error) {
        this.setButtonState(button, label, 'default');
        this.showError(errorBox, error.message || this.errorText);
        button.dataset.busy = 'false';
      }
    }

    getSectionsToRender() {
      const sections = [];

      if (document.querySelector('cart-drawer')) sections.push('cart-drawer');
      if (document.querySelector('cart-notification')) sections.push('cart-notification');
      if (document.querySelector('#cart-icon-bubble')) sections.push('cart-icon-bubble');

      return sections;
    }

    updateCartUI(data) {
      if (!data.sections) return;

      Object.entries(data.sections).forEach(([sectionId, html]) => {
        if (!html) return;

        const doc = new DOMParser().parseFromString(html, 'text/html');

        if (sectionId === 'cart-icon-bubble') {
          const target = document.querySelector('#cart-icon-bubble');
          const fresh = doc.querySelector('#shopify-section-cart-icon-bubble');
          if (target && fresh) target.innerHTML = fresh.innerHTML;
        }

        if (sectionId === 'cart-drawer') {
          const target = document.querySelector('cart-drawer');
          const fresh = doc.querySelector('cart-drawer');
          if (target && fresh) target.innerHTML = fresh.innerHTML;
        }

        if (sectionId === 'cart-notification') {
          const target = document.querySelector('cart-notification');
          const fresh = doc.querySelector('cart-notification');
          if (target && fresh) target.innerHTML = fresh.innerHTML;
        }
      });
    }

    openCart() {
      const drawer = document.querySelector('cart-drawer');

      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }

      if (drawer) {
        drawer.classList.add('active', 'animate');
        drawer.classList.remove('is-empty');
        return;
      }

      const notification = document.querySelector('cart-notification');

      if (notification && typeof notification.open === 'function') {
        notification.open();
        return;
      }

      if (this.cartType === 'page') {
        window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
      }
    }

    setButtonState(button, label, state) {
      if (state === 'default') {
        button.removeAttribute('data-state');
        if (label) label.textContent = this.defaultText;
        return;
      }

      button.dataset.state = state;

      if (label) {
        if (state === 'loading') label.textContent = this.loadingText;
        if (state === 'success') label.textContent = this.successText;
      }
    }

    showError(errorBox, message) {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.hidden = false;
    }

    hideError(errorBox) {
      if (!errorBox) return;
      errorBox.hidden = true;
      errorBox.textContent = '';
    }
  }

  function initCustomUpsellCarousels(container) {
    const scope = container || document;

    scope.querySelectorAll('[data-custom-upsell-carousel]').forEach((root) => {
      if (root.dataset.customUpsellCarouselInitialized === 'true') return;

      root.dataset.customUpsellCarouselInitialized = 'true';
      new CustomUpsellCarousel(root);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initCustomUpsellCarousels(document));
  document.addEventListener('shopify:section:load', (event) => initCustomUpsellCarousels(event.target));
  document.addEventListener('shopify:block:select', (event) => initCustomUpsellCarousels(event.target));
})();